import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../middleware/dataSlice';

export interface LoginRequest {
  userName: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
  userInfo: {
    email: string;
    companyId: number;
    companyName: string;
    selectedUserInfo: number;
  }[];
}

interface TokenResponse {
  data: {
    token: string;
    expiration: string;
  };
  success: boolean;
  message: string;
  statusCode: number;
}

interface VerifyResponse {
  data: {
    token: string;
    expiration: string;
    // Login sonrasında 2FA verify cevabından gelen refreshToken
    refreshToken?: string;
  };
  success: boolean;
  message: string;
  statusCode: number;
}

interface VerifyCodePayload {
  code: string;
  methodName: string;
  provider: string;
  Ip: null;
  deviceId: null;
  deviceToken: null;
}

interface ForgotPasswordRequest {
  email: string;
  Ip: string;
}

interface ForgotPasswordResponse {
  data: {
    token: string;
    expiration: string;
  };
  success: boolean;
  message: string;
  statusCode: number;
}

interface ResetPasswordRequest {
  ip: string;
  confirmPassword: string;
  password: string
}

interface ResetPasswordResponse {
  success: boolean;
  message: string;
  statusCode: number;
}
type ChangePasswordResponse = {
  success: boolean;
  message: string;
  statusCode: number;
}
type ChangePasswordRequest = {
  confirmPassword: string;
  newPassword: string;
  oldPassword: string;
  ip: string;
}

export interface RefreshTokenRequest {
  refreshToken: string | null;
}

export interface RefreshTokenResponse {
  success: boolean;
  message?: string;
  statusCode?: number;
  data?: {
    token: string;
    refreshToken: string;
  };
}

interface LogoutResponse {
  success: boolean;
  message?: string;
  statusCode?: number;
}

export const authenticationApi = createApi({
  reducerPath: 'authenticationApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    login: builder.mutation<TokenResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: (responseData: TokenResponse) => {
        if (responseData.success && responseData.data?.token) {
          localStorage.setItem('accessToken', responseData.data.token);
        }
        return responseData;
      },
    }),
    verifyCode: builder.mutation<VerifyResponse, string>({
      query: (code) => ({
        url: '/auth/verifycode',
        method: 'POST',
        body: {
          code,
          methodName: "corporateLogin",
          provider: "E",
          Ip: null,
          deviceId: null,
          deviceToken: null
        } as VerifyCodePayload,
      }),
      transformResponse: (responseData: VerifyResponse) => {
        if (responseData.success && responseData.data?.token) {

          localStorage.setItem('verifyToken', responseData.data.token);
        }
        return responseData;
      },
    }),
    resendCode: builder.mutation<TokenResponse, void>({
      query: () => ({
        url: '/auth/resendcode',
        method: 'GET', // Changed from POST to GET
      }),
    }),
    forgotPassword: builder.mutation<ForgotPasswordResponse, ForgotPasswordRequest>({
      query: (data) => ({
        url: '/auth/forgotpassword',
        method: 'POST',
        body: data,
      }),
      transformResponse: (responseData: ForgotPasswordResponse) => {
        if (responseData.success && responseData.data?.token) {
          localStorage.setItem('forgotPasswordToken', responseData.data.token);
        }
        return responseData;
      },
    }),
    resetPassword: builder.mutation<ResetPasswordResponse, ResetPasswordRequest>({
      query: (data) => ({
        url: '/auth/resetpassword',
        method: 'POST',
        body: data,
      }),
    }),
    changepassword: builder.mutation<ChangePasswordResponse, ChangePasswordRequest>({
      query: (data) => ({
        url: '/auth/changepassword',
        method: 'POST',
        body: data,
      }),
    }),
    refreshtoken: builder.mutation<RefreshTokenResponse, RefreshTokenRequest>({
      query: (body) => ({
        url: '/Auth/refreshtoken',
        method: 'POST',
        body,
      }),
    }),
    logout: builder.mutation<LogoutResponse, void>({
      query: () => ({
        url: '/Auth/logout',
        method: 'POST',
        body: {},
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useVerifyCodeMutation,
  useResendCodeMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangepasswordMutation,
  useRefreshtokenMutation,
  useLogoutMutation,
} = authenticationApi;
